class ParallaxMotto {
  constructor() {
    this.showcaseText = document.querySelector("#showcase__header");
    this.events();
  }

  events() {
    addEventListener("scroll", () => this.parallax());
  }

  parallax() {
    if (window.scrollY > 1300) return;
    const x = 1.1 * window.scrollY;
    this.showcaseText.style.transform = `translateY(${x}px)`;
  }
}

export default ParallaxMotto;
